import { LogoutOptions, useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import LoginService from 'services/login-service'

function useLogout() {
  const { logout } = useAuth0()

  function managedLogout(options?: LogoutOptions) {
    for (const listener of LoginService.logoutListeners) {
      listener()
    }

    console.log('Logging Out - Managed')

    logout(options)
  }

  return managedLogout
}

export default useLogout
